export default __webpack_public_path__ + "static/media/bidifylogo_zksync.09d746ac.png";